import React, { Fragment } from "react";
import "./App.css";
import Routers from "./Routes";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/customizer/CustomizerProvider";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import { store } from "./app/store";
import { fetchNavbar } from "./Auth/api";
import HotelPage from "./Pages/HomePage/HotelPage";

function App() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log(
            "ServiceWorker registration successful with scope: ",
            registration.scope
          );

          // Check for updates to the service worker
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  console.log("New content is available; please refresh.");
                } else {
                  console.log("Content is now available offline!");
                }
              }
            });
          });
        })
        .catch((error) => {
          console.log("ServiceWorker registration failed: ", error);
        });

      // Handle updates to the service worker
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (!refreshing) {
          window.location.reload();
          refreshing = true;
        }
      });
    });
  }

  let hotelCode = localStorage.getItem("hotelcode");
  console.log("App.js >> hotelCode:", hotelCode);

  return (
    <Provider store={store}>
      <Fragment>
        <CustomizerProvider>
          <AnimationThemeProvider>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/"
                  element={
                    !hotelCode ? <HotelPage /> : <Navigate to={'login'} />
                  }
                />

                <Route path="/*" element={<Routers />} />
              </Routes>
            </BrowserRouter>
          </AnimationThemeProvider>
        </CustomizerProvider>
      </Fragment>
    </Provider>
  );
}
export default App;
